import { FC } from 'react'

import {
  Loader as MantineLoader,
  LoaderProps as MantineLoaderProps,
} from '@mantine/core'
import styled from 'styled-components'

const StyledLoader = styled(MantineLoader)`
  /* Здесь можно добавить кастомные стили */
`

export type LoaderProps = MantineLoaderProps

export const Loader: FC<LoaderProps> = (props) => {
  return <StyledLoader {...props} />
}
